import React, { useEffect, useState } from "react";
import images from "../../assets/Icons/Icons";
import "./MobileUnsupportedModal.scss";

const MOBILE_QUERY = "(max-width: 768px)";

const MobileUnsupportedModal: React.FC = () => {
  const [isMobile, setIsMobile] = useState<boolean>(() => {
    if (typeof window === "undefined") return false;
    return window.matchMedia ? window.matchMedia(MOBILE_QUERY).matches : false;
  });

  useEffect(() => {
    if (typeof window === "undefined" || !window.matchMedia) return;

    const mq = window.matchMedia(MOBILE_QUERY);
    const handler = (e: MediaQueryListEvent | MediaQueryList) => {
      // support both event and MediaQueryList
      const matches = (e as any).matches;
      setIsMobile(matches);
    };

    // addEventListener preferred, fallback to addListener
    if (typeof mq.addEventListener === "function") {
      mq.addEventListener("change", handler as any);
    } else if (typeof mq.addListener === "function") {
      // older browsers
      mq.addListener(handler as any);
    }

    return () => {
      if (typeof mq.removeEventListener === "function") {
        mq.removeEventListener("change", handler as any);
      } else if (typeof mq.removeListener === "function") {
        mq.removeListener(handler as any);
      }
    };
  }, []);

  // prevent background scrolling when modal is visible
  useEffect(() => {
    if (!isMobile) return;
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = prev;
    };
  }, [isMobile]);

  if (!isMobile) return null;

  return (
    <div className="mobile-modal-overlay" role="dialog" aria-modal="true">
      <div className="mobile-modal-inner">
        {/* Decorative Yeti behind the card */}
        <img src={images.yeti} alt="Yeti" className="mobile-yeti-hero" />

        <div className="mobile-modal-card">
          <p className="mobile-modal-message">Please switch to a desktop or laptop. Not supported on mobile.</p>
        </div>
      </div>
    </div>
  );
};

export default MobileUnsupportedModal;
